<div class="sidebar">
  <ul class="side-nav">
    <li
      class="side-nav__item"
      (click)="setActive('MenuList')"
      [class.side-nav__item--active]="activeLink === 'MenuList'"
    >
      <a [routerLink]="'/admin/menuList'" class="side-nav__link">
        <span class="side-nav__text">Menu List</span>
      </a>
    </li>

    <li
      class="side-nav__item"
      (click)="setActive('CategoriesList')"
      [class.side-nav__item--active]="activeLink === 'CategoriesList'"
    >
      <a [routerLink]="'/admin/categories'" class="side-nav__link">
        <span class="side-nav__text">Categories List</span>
      </a>
    </li>

    <li
      class="side-nav__item"
      (click)="setActive('MenuOrder')"
      [class.side-nav__item--active]="activeLink === 'MenuOrder'"
    >
      <a [routerLink]="'/admin/orderItems'" class="side-nav__link">
        <span class="side-nav__text">Menu Order</span>
      </a>
    </li>

    <li
      class="side-nav__item"
      (click)="setActive('CategoryOrder')"
      [class.side-nav__item--active]="activeLink === 'CategoryOrder'"
    >
      <a [routerLink]="'/admin/orderCategories'" class="side-nav__link">
        <span class="side-nav__text">Category Order</span>
      </a>
    </li>

    <li
      class="side-nav__item"
      (click)="setActive('addCoupon')"
      [class.side-nav__item--active]="activeLink === 'addCoupon'"
    >
      <a [routerLink]="'/admin/addCoupon'" class="side-nav__link">
        <span class="side-nav__text">Add Coupon</span>
      </a>
    </li>

    <li
      class="side-nav__item"
      (click)="setActive('ExportMenu')"
      [class.side-nav__item--active]="activeLink === 'ExportMenu'"
    >
      <a [routerLink]="'/admin/exportMenu'" class="side-nav__link">
        <span class="side-nav__text">Export Menu</span>
      </a>
    </li>
  </ul>

  <div class="legal">Arada Group</div>
</div>
